
import * as React from "react";
import FilterForm from "./header/FilterForm";
import { ISetUrl } from "../AppMain";
import { Url } from "../../avernus/url/source/Url";
import { Api } from "../lib/Api";
import DateTool from "../../avernus/datetool/source/DateTool";
import { IActiveOrders } from "../interfaces/IOrder";
import { Lng } from "../../languages/Languages";
import { IViewForViewRestaurant } from "./user/ViewRestaurant";
import { Order } from "./user/Order";
import {TStorage} from "../../avernus/tstorage/TStorage";
import OfferListTitle from "./user/OfferListTitle";

interface IHeaderProps {
    setUrl              : ISetUrl
    title?              : string
    titleIconImage?     : string
    titleIconImageWidth?: number
    subTitle?           : string
    headerImg?          : string
    showSearchForm?     : boolean
    shortByEnabled?     : boolean
    orderBy       ?     : 'ASC'|'DESC'
    changedOrder  ?     : Function
    titleFormated?      : boolean
    description?        : string
    getActiveOrders?    : boolean
    userWelcome?        : boolean
    category?           : Array<ICategory>
}

interface ICategory {
    name: string
    id: Number
    img: string
}

interface IchangeViewForViewRestaurant{
    (viewForViewRestaurant:IViewForViewRestaurant):void
}


interface IHeaderState {
    items:Array<IActiveOrders>
    activeOrderItemNum    :number
}

interface IresultGetActiveOrders{
    items:Array<IActiveOrders>
}

export default class Header extends React.Component<IHeaderProps, IHeaderState>{

    private getActiveOrders:boolean;

    constructor(props:IHeaderProps){
        super(props);
        this.state = {
            items: [],
            activeOrderItemNum: 0
        };

        if ( this.isRestaurantInterface() ) {
            this.getActiveOrderItemNumber()
        }
    }


    private getActiveOrderItemNumber(){
        this.setState({
            activeOrderItemNum: 0
        });
        /*Api.call('/restaurants/order/getOrders', {
            restaurantId            : Api.getCurrentRestaurant().id,
            fromDate                : DateTool.getDate(),
            toDate                  : DateTool.getDate(),
            showJustActiveOrders    : true
        }, (result)=>{
            this.setState({
                activeOrderItemNum: result.items.length
            });
        });*/
    }

    private getActiveOrder(){
        Api.call('/user/order/getActiveOrders', {}, (result:IresultGetActiveOrders)=>{
            // console.log('getActiveOrders', result);
            this.setState({
                items: result.items
            });
        });
    }

    private filterChangedHandler(str): void {
        this.props.setUrl('/user/offers/', {
            filter: str
        });
    }

    private toogleOrderByClicHandler(evt): void {
        evt.preventDefault();
        this.props.changedOrder();
    }

    private isUserInterface():boolean{
        if ( Url.getUrlPart(0) === 'user' ) {
            return true;
        }
        return false;
    }

    private isRestaurantInterface():boolean{
        if ( Url.getUrlPart(0) === 'restaurant' ) {
            return true;
        }
        return false;
    }

    private isAdminInterface():boolean{
        if ( Url.getUrlPart(0) === 'admin' ) {
            return true;
        }
        return false;
    }

    private loginClickHandler(evt): void {
        evt.preventDefault();
        Api.cleanStorage();
        this.props.setUrl('/login');
        // window.location.href = '/login';
    }

    render() {
        let showBackBtn:boolean         = !Url.isUrl(/index/);
        let showHamubregMenu: boolean   = true;
        let showSearchForm:boolean      = this.props.showSearchForm !== undefined && this.props.showSearchForm === true;
        let shortByEnabled:boolean      = this.props.shortByEnabled !== undefined && this.props.shortByEnabled === true;
        let title                       = null;
        let subTitle                    = null;
        if ( this.props.title !== undefined ) {
            title = this.props.title;
        }
        if ( this.props.subTitle !== undefined ) {
            subTitle = this.props.subTitle;
        }
        let headerImg:string             = this.props.headerImg !== undefined?this.props.headerImg:null;
        let titleIconImage:string        = this.props.titleIconImage !== undefined?this.props.titleIconImage:null;
        let titleIconImageWidth:number   = this.props.titleIconImageWidth !== undefined?this.props.titleIconImageWidth:null;
        let titleFormated:boolean        = this.props.titleFormated !== undefined?this.props.titleFormated:false;
        // console.log('active offer items length', this.state.items.length);
        let backUrl:Array<string> = ['-1'];
        // if ( Url.isUrl(/user\/payment/) === true) {
        //     backUrl = '/user/offers';
        // }
        if ( Url.isUrl(/user\/offers/) === true) {
            backUrl = ['/user/index', '/user/offers']; //life hack fix
        }
        return (
            <>
                <div className="header_section_placeholder"/>
                <div className="container header_section">
                    <header>
                        <nav>
                            <div className="row">
                                <div className = "col">
                                    {
                                        this.state.items.length>0?this.activeOrdersView(headerImg, showHamubregMenu, showSearchForm):this.defaultFigure(showHamubregMenu)
                                    }
                                </div>
                                <div className="col text-center">
                                    <a onClick={ e => this.props.setUrl('/'+Url.getUrlPart(0)+'/index') }>
                                        <img className="logo" src="img/opus_logo_inverse_min.svg" width={100} />
                                    </a>
                                </div>
                                <div className="col text-right">
                                    { this.isUserInterface() === true  || this.isAdminInterface() === true?<>
                                        {Api.isFrontUser() ? <a onClick={e => this.props.setUrl('/' + Url.getUrlPart(0) + '/profile')} style={this.isAdminInterface() === true?{'display':'none'}:{}}>
                                            <img src="img/user_profile_icon.svg" width={30} alt="" />
                                        </a> : <a onClick={e => this.loginClickHandler(e)}>
                                            <img src="img/user_profile_icon.svg" width={30} alt="" />
                                        </a>}
                                    </>:<a onClick={ e => this.props.setUrl('/restaurant/active-orders') } className="active_order_btn">
                                        <img src="img/order_icon.svg" width={26} alt=""/>
                                        { this.state.activeOrderItemNum > 0?<span>{ this.state.activeOrderItemNum }</span>:'' }
                                    </a> }
                                </div>

                            </div>
                        </nav>

                        {
                            this.props.category &&
                            <OfferListTitle category={this.props.category} title = {title} />
                        }


                        {/*
                        {shortByEnabled === true &&
                            <a className="ordery_by_btn" onClick={(e) => { this.toogleOrderByClicHandler(e); } }>
                                <span>{Lng.get('sort_by')}</span> <img src="img/arrow_icon.svg" className={this.props.orderBy} width={13} alt="" />
                            </a>
                        }*/}
                    </header>
                </div>
            </>
        );
    }

    private activeOrdersView(headerImg: string, showHamubregMenu: boolean, showSearchForm: boolean){
        return <>
            <div className="fig activer_order_row">
                <div>
                    {showHamubregMenu === true ? <a onClick={e => {
                        e.preventDefault();
                        this.props.setUrl('/'+Url.getUrlPart(0)+'/menu');
                    } } className="hemburger_menu">
                        <img src="img/hamburger_menu_icon.svg" width={25} alt="menu" />
                    </a> : ''}

                </div>

            </div>
            <div className="fig" style={headerImg !== null ? {
                backgroundImage: `url(${headerImg})`
            } : {}}>
                <div className="row d-flex d-lg-flex">

                </div>

                {showSearchForm === true ? <FilterForm changed={str => this.filterChangedHandler(str)} /> : ''}
            </div>
        </>
    }

    private defaultFigure(showHamubregMenu: boolean) {
        return <div className="fig">
            <div>
                {showHamubregMenu === true ? <a onClick={e => {
                    e.preventDefault();
                    this.props.setUrl('/'+Url.getUrlPart(0)+'/menu');
                } } className="hemburger_menu">
                    <img src="img/hamburger_menu_icon.svg" width={25} alt="menu" />
                </a> : ''}

            </div>

            { this.props.children !== undefined?this.props.children:'' }
        </div>;
    }
}
